import { render, staticRenderFns } from "./InputTaggable.vue?vue&type=template&id=8a6e4354&scoped=true"
import script from "./InputTaggable.vue?vue&type=script&lang=js"
export * from "./InputTaggable.vue?vue&type=script&lang=js"
import style0 from "./InputTaggable.vue?vue&type=style&index=0&id=8a6e4354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6e4354",
  null
  
)

export default component.exports